import { Text, View } from 'react-native';
import { SubmissionStatus } from '../types';
import { colors, fonts } from '../theme';

export const SUBMISSION_STATUS_LABELS: Record<SubmissionStatus, string> = {
  ACCEPTED: 'Cần check-in',
  CHECKED_IN: 'Cần nộp bài',
  SUBMITTED: 'Chờ duyệt',
  APPROVED: 'Đã duyệt',
  REJECTED: 'Bị từ chối',
  CANCELLED: 'Đã hủy',
};

const COLORS: Record<SubmissionStatus, string> = {
  ACCEPTED: colors.warning,
  CHECKED_IN: colors.warning,
  SUBMITTED: colors.textMuted,
  APPROVED: colors.success,
  REJECTED: colors.danger,
  CANCELLED: colors.textMuted,
};

export function StatusBadge({ status }: { status: SubmissionStatus }) {
  const color = COLORS[status];
  return (
    <View
      style={{
        backgroundColor: `${color}20`,
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 6,
        alignSelf: 'flex-start',
      }}
    >
      <Text style={{ color, fontSize: 11, fontFamily: fonts.bold }}>{SUBMISSION_STATUS_LABELS[status]}</Text>
    </View>
  );
}
